// NOTE: As of 2022-04-29 [area-]square-[kilo]meter is not supported in Intl.NumberFormat
import { formatLength } from "./formatLength";
/**
 * Format area
 *
 * @param area The area in square meters
 * @param options options
 * @returns Formatted area string
 */
export function formatArea(area, options) {
    return `${formatLength(area, options)}²`;
}
